import React, { useEffect, useState } from "react";
import "./index.scss";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  Autocomplete,
  Badge,
  Box,
  Button,
  Tab,
  Tabs,
  TextField,
} from "@mui/material";

import { isActionAllowed } from "../../utils/common-utils";
import BudgetApprovalList from "../budget/budget-approval-list";
import POApprovalList from "../purchase-order/po-approval-list";
import PRApprovalList from "../purchase-requisition/pr-approval-list";
import GRNApprovalList from "../goods-receive-notes/grn-approval-list";
import InvoiceApprovalList from "../invoices-data/invoice-approval-list";
import VendorMappingApprovalList from "../master-data/vendor-item-map/vendor-mapping-approval";
import { HTTP_METHODS, invokeApi } from "../../utils/http-service";
import { FINANCE_V2_HOSTNAME } from "../../../common-utilities/utils/end-points";
import { FINANCE_REST_URLS } from "../../../common-utilities/utils/end-points/finance-v2";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}
const MyPendingActions = ({ getCountOfPendingRequest }) => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const openTabIndex = searchParams.get("subIndex");
  const mainTabIndex = searchParams.get("index");
  const [value, setValue] = useState(+openTabIndex || 0);
  const [noOfPendingPo, setNoOfPendingPo] = useState(0);
  const [noOfPendingPr, setNoOfPendingPr] = useState(0);
  const [noOfPendingGrn, setNoOfPendingGrn] = useState(0);
  const [noOfPendingPayment, setNoOfPendingPayment] = useState(0);
  const [noOfPendingBudget, setNoOfPendingBudget] = useState(0);
  const [noOfPendingVendorMapping, setNoOfPendingVendorMapping] = useState(0);
  const [isLandingTabResolved, setIsLandingTabResolved] = useState(
    openTabIndex !== null
  );
  const [areLandingCountsLoaded, setAreLandingCountsLoaded] = useState(false);

  const handleChange = (event, newValue) => {
    setSearchParams({
      index: mainTabIndex || 0,
      subIndex: newValue,
    });
    setValue(newValue);
    setIsLandingTabResolved(true);
  };
  const getPendingVendorMapping = () => {
    return invokeApi(
      HTTP_METHODS.POST,
      `${FINANCE_V2_HOSTNAME}${FINANCE_REST_URLS.GET_MY_APPROVALS}`,
      null,
      {
        approvalType: "vendor_mapping",
        status: "approval_in_progress",
      }
    )
      .then((response) => {
        if (response.message) {
        } else {
          setNoOfPendingVendorMapping(response?.length || 0);
        }
      })
      .catch((err) => {});
  };
  const tabs = [
    {
      label: "Budget",
      component: (
        <BudgetApprovalList
          searchPlaceHolder="Search by Budget Id"
          status="lineitem_approval"
        />
      ),
      badgeCount: noOfPendingBudget,
    },
    {
      label: "PR",
      component: (
        <PRApprovalList
          searchPlaceHolder="Search by PR Number"
          approvalType="pr_approval"
          status="approval_in_progress"
        />
      ),
      badgeCount: noOfPendingPr,
    },
    {
      label: "PO",
      component: (
        <POApprovalList
          searchPlaceHolder="Search by Po Number"
          approvalType="po_approval"
          status="approval_in_progress"
        />
      ),
      badgeCount: noOfPendingPo,
    },
    {
      label: "GRN",
      component: (
        <GRNApprovalList
          approvalType="invoice_approval"
          usedIn="GRN"
          status="approval_in_progress"
        />
      ),
      badgeCount: noOfPendingGrn,
    },
    {
      label: "Advance Payment",
      component: (
        <InvoiceApprovalList
          approvalType="invoice_approval"
          usedIn="INVOICE_DATA"
          status="approval_in_progress"
          invoiceType="advance_invoice"
        />
      ),
      badgeCount: noOfPendingPayment,
    },
    {
      label: "Vendor Mapping",
      component: (
        <VendorMappingApprovalList
          searchPlaceHolder="Search by Vendor Name / Code"
          approvalType="vendor_mapping"
          status="approval_in_progress"
          getPendingVendorMapping={getPendingVendorMapping}
        />
      ),
      badgeCount: noOfPendingVendorMapping,
    },
    {
      label: "Budget Line Item",
      component: (
        <BudgetApprovalList
          searchPlaceHolder="Search by Budget Id"
          status="lineitem_approval"
          usedIn="LINE_ITEM"
        />
      ),
      badgeCount: noOfPendingBudget,
    },
  ];

  // Filter tabs based on user's access rights
  const accessibleTabs = tabs.filter((tab, index) => {
    switch (tab.label) {
      case "Budget":
        return isActionAllowed("budget");
      case "Budget Line Item":
        return noOfPendingBudget > 0;
      case "PR":
        return isActionAllowed("pr");
      case "PO":
        return isActionAllowed("po");
      case "Vendor Mapping":
        return isActionAllowed("po");
      case "GRN":
        return isActionAllowed("grn");
      case "Advance Payment":
        return isActionAllowed("advancePayment");

      default:
        break;
    }
  });
  const loadPendingData = () => {
    return invokeApi(
      HTTP_METHODS.POST,
      `${FINANCE_V2_HOSTNAME}${FINANCE_REST_URLS.GET_MY_APPROVALS}`,
      null,
      {
        approvalType: "invoice_approval",
        invoiceType: "advance_invoice",
        status: "approval_in_progress",
      }
    )
      .then((response) => {
        if (response.message) {
        } else {
          setNoOfPendingPayment(response?.length || 0);
        }
      })
      .catch((err) => {});
  };
  const getPendingPo = () => {
    return invokeApi(
      HTTP_METHODS.POST,
      `${FINANCE_V2_HOSTNAME}${FINANCE_REST_URLS.GET_MY_APPROVALS}`,
      null,
      {
        approvalType: "po_approval",
        status: "approval_in_progress",
      }
    )
      .then((response) => {
        if (response.message) {
        } else {
          setNoOfPendingPo(response?.length);
        }
      })
      .catch((err) => {});
  };
  const getPendingPr = () => {
    return invokeApi(
      HTTP_METHODS.POST,
      `${FINANCE_V2_HOSTNAME}${FINANCE_REST_URLS.GET_MY_APPROVALS}`,
      null,
      {
        approvalType: "pr_approval",
        status: "approval_in_progress",
      }
    )
      .then((response) => {
        if (response.message) {
        } else {
          setNoOfPendingPr(response?.length || 0);
        }
      })
      .catch((err) => {});
  };
  const getPendingGrn = () => {
    return invokeApi(
      HTTP_METHODS.POST,
      `${FINANCE_V2_HOSTNAME}${FINANCE_REST_URLS.GET_MY_APPROVALS}`,
      null,
      {
        approvalType: "invoice_approval",
        invoiceType: "grn_invoice",
        status: "approval_in_progress",
      }
    )
      .then((response) => {
        if (response.message) {
        } else {
          setNoOfPendingGrn(response?.length);
        }
      })
      .catch((err) => {});
  };
  const getPendingBudget = () => {
    return invokeApi(
      HTTP_METHODS.POST,
      `${FINANCE_V2_HOSTNAME}${FINANCE_REST_URLS.GET_MY_APPROVALS}`,
      null,
      {
        approved: false,
        rejected: false,
        approvalType: "lineitem_approval",
        sortBy: "-createdAt",
        populateSite: true,
      }
    )
      .then((response) => {
        if (response.message) {
        } else {
          setNoOfPendingBudget(response?.length);
        }
      })
      .catch((err) => {});
  };
 
  useEffect(() => {
    const landingCountRequests = [getPendingBudget()];
    if (isActionAllowed("po")) {
      landingCountRequests.push(getPendingPo());
    }
    if (isActionAllowed("pr")) {
      landingCountRequests.push(getPendingPr());
    }
    if (isActionAllowed("grn")) {
      landingCountRequests.push(getPendingGrn());
    }
    if (isActionAllowed("advancePayment")) {
      landingCountRequests.push(loadPendingData());
    }
    if (isActionAllowed("po")) {
      landingCountRequests.push(getPendingVendorMapping());
    }
    Promise.all(landingCountRequests).finally(() =>
      setAreLandingCountsLoaded(true)
    );
  }, []);
  useEffect(() => {
    if (!areLandingCountsLoaded || isLandingTabResolved) {
      return;
    }
    const landingIndex = accessibleTabs.findIndex((tab) => tab.badgeCount > 0);
    if (landingIndex > -1) {
      setSearchParams(
        { index: mainTabIndex || 0, subIndex: landingIndex },
        { replace: true }
      );
      setValue(landingIndex);
    }
    setIsLandingTabResolved(true);
  }, [areLandingCountsLoaded]);
  useEffect(() => {
    const count =
      noOfPendingPr +
      noOfPendingPo +
      noOfPendingGrn +
      noOfPendingPayment +
      noOfPendingBudget +
      noOfPendingVendorMapping;
    getCountOfPendingRequest(count);
  }, [
    noOfPendingPr,
    noOfPendingPo,
    noOfPendingGrn,
    noOfPendingPayment,
    noOfPendingBudget,
    noOfPendingVendorMapping,
  ]);

  return (
    <div className="finance-v2-rm-pt finance-v2-budget-list ">
      <div className="tabs-section">
        {accessibleTabs.length > 0 ? (
          <Box>
            <Tabs
              variant="scrollable"
              value={isLandingTabResolved ? value : false}
              onChange={handleChange}
              sx={{
                borderBottom: "1px solid #DDE2EC",
                "& .MuiTabs-indicator": { display: "none" },
                "& .MuiTab-root": {
                  color: "#5B6E8A",
                  minWidth: "unset",
                  borderRadius: "20px",
                  margin: "0 2px",
                  textTransform: "none",
                  "& .MuiBadge-root": {
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "4px",
                  },
                  "& .MuiBadge-badge": {
                    position: "relative",
                    transform: "none",
                    top: "auto",
                    right: "auto",
                    background: "transparent",
                    color: "#007A42",
                    minWidth: "unset",
                    height: "auto",
                    padding: 0,
                    fontSize: "0.68rem",
                    fontWeight: 700,
                    lineHeight: 1,
                    borderRadius: 0,
                    boxShadow: "none",
                    "&.MuiBadge-invisible": { display: "none" },
                  },
                },
                "& .Mui-selected": {
                  color: "#005F35 !important",
                  background: "#EAF4EE",
                  "& .MuiBadge-badge": {
                    background: "#005F35",
                    color: "#fff",
                    minWidth: "16px",
                    height: "16px",
                    padding: "0 3px",
                    fontSize: "0.65rem",
                    fontWeight: 700,
                    borderRadius: "50%",
                  },
                },
              }}
              TabIndicatorProps={{ sx: { display: "none" } }}
            >
              {accessibleTabs.map((tab, index) => (
                <Tab
                  key={index}
                  label={
                    <Badge badgeContent={tab.badgeCount || 0} color="primary">
                      {tab.label}
                    </Badge>
                  }
                  sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }}
                />
              ))}
            </Tabs>
          </Box>
        ) : (
          <p>Not authorized to take actions </p>
        )}
      </div>
      {isLandingTabResolved &&
        accessibleTabs.map((tab, index) => (
          <TabPanel key={index} value={value} index={index}>
            {tab.component}
          </TabPanel>
        ))}
    </div>
  );
};

export default MyPendingActions;
